import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export const RootRedirect = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Redirigir según el rol del usuario
  if (user.role === 'admin') {
    return <Navigate to="/admin" replace />;
  } else if (user.role === 'bodega') {
    return <Navigate to="/bodega" replace />;
  } else if (user.role === 'logistica') {
    return <Navigate to="/logistica" replace />;
  } else if (user.role === 'inventarista') {
    return <Navigate to="/inventarista" replace />;
  } else {
    return <Navigate to="/local" replace />;
  }
};
